module.exports = __webpack_public_path__ + "static/media/new_bot.34337dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/docs/img/new_bot.png
// module id = 981
// module chunks = 0